import { useCustomerWithId } from "../../customers/useCustomerWithId";

export interface CustomerContact {
  readonly name: string;
  readonly email: string;
  readonly loginEmails: string[];
}

export function useCustomerContact(customerId: string | null | undefined): {
  isLoading: boolean;
  isError: boolean;
  contact: CustomerContact | null;
  accountManagerId: string | null;
} {
  const { customer, isLoading, isError } = useCustomerWithId(customerId ?? undefined);
  if (!customer || isError) {
    return { isLoading, isError, contact: null, accountManagerId: null };
  }
  const contacts = customer.contacts ?? [];
  const firstContact = contacts.at(0);
  const email = firstContact?.email;
  if (!email) {
    return { isLoading, isError, contact: null, accountManagerId: null };
  }
  return {
    isLoading,
    isError,
    contact: {
      name: `${customer.name} (${firstContact.name})`,
      email,
      loginEmails: contacts.map((c) => c.loginEmail).filter((v): v is string => !!v),
    },
    accountManagerId: customer.accountManager?.id ?? null,
  };
}
